import { render, staticRenderFns } from "./NewContactsSidebar.vue?vue&type=template&id=1b766c6a&"
import script from "./NewContactsSidebar.vue?vue&type=script&lang=js&"
export * from "./NewContactsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports